export function replaceRouteParams(route, ...args) {
    let result = route;
    for (let i = 0; i < args.length; i++) {
        result = result.replace(/{.*?}/, encodeURIComponent(args[i]));
    }
    return result;
}